import React, { FC, useEffect, useRef } from "react";
import injectSheet from "react-jss";
import styleSheet from "./styles";

interface Props {
  classes: any;
  changeTableWidth?: (width: any) => void;
}

const TableHeader: FC<Props> = props => {
  const tableWidth = useRef(null);

  useEffect(() => {
    props.changeTableWidth &&
      props.changeTableWidth(tableWidth.current.scrollWidth);
  });

  return (
    <div className={props.classes.header} ref={tableWidth}>
      {props.children}
    </div>
  );
};

export default injectSheet(styleSheet)(TableHeader);
